module.exports = __webpack_public_path__ + "img/Jen Seku.06eaabbb.png";